import React from "react";
import { CircularProgress, RaisedButton, TextField } from "material-ui";
import { Link } from "react-router";

import connectToStores from "alt-utils/lib/connectToStores";
import UserActions from "../actions/UserActions";
import UserStore from "../stores/UserStore";

class Activate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      confirmPassword: "",
      hasStartedConfirming: false,
      activating: false
    };

    this._activate = this._activate.bind(this);
  }

  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores() {
    return UserStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired
    };
  }

  _activate() {
    this.setState({ activating: true });
    UserActions.edit({ password: this.state.password });
  }

  componentWillMount() {
    UserActions.logout.defer(/* noRedirect */ true);

    try {
      let [username, password] = atob(this.props.location.query.token).split(
        ";"
      );
      this.setState({ username: username });
      UserActions.login.defer(username, password, /* noRedirect */ true);
    } catch (e) {
      UserActions.editFailed(e);
    }
  }

  componentWillReceiveProps(newProps) {
    if (this.state.activating && newProps.isLoggedIn) {
      this.context.router.push("/welcome");
    }
  }

  componentDidMount() {
    if (this.field) {
      this.field.focus();
    }
  }

  getStyles() {
    return {
      container: {
        margin: "20px auto",
        marginTop: "10%",
        width: 270
      },
      actions: {
        marginTop: 10,
        textAlign: "center"
      },
      terms: {
        marginTop: "1em",
        textAlign: "center",
        fontSize: "1em",
        lineHeight: 1.5,
        color: "#a7a7a7"
      },
      termsLink: {
        color: "#8a8a8a"
      },
      error: {
        color: "#FF4136"
      }
    };
  }

  render() {
    let styles = this.getStyles(),
      error = this.props.loginErrorMessage || this.props.editErrorMessage;

    if (error && error.indexOf("Invalid password") !== -1) {
      return (
        <div style={Object.assign({}, styles.container, styles.error)}>
          This account has already been activated.{" "}
          <Link
            to={{
              pathname: "/login",
              state: { username: this.state.username, clearErrors: true }
            }}
          >
            Login&nbsp;instead.
          </Link>
        </div>
      );
    }

    return (
      <div style={styles.container}>
        {error ? (
          <div style={styles.error}>Failed to activate account: {error}</div>
        ) : (
          <div>
            Welcome to Eventive! To continue, please set a password for your
            account.
          </div>
        )}
        <form>
          <div>
            <TextField
              floatingLabelText="Email address"
              value={this.state.username}
              disabled={true}
            />
          </div>
          <div>
            <TextField
              ref={r => {
                this.field = r;
              }}
              floatingLabelText="New password"
              floatingLabelFixed={true}
              value={this.state.password}
              onChange={e => this.setState({ password: e.target.value })}
              type="password"
              disabled={this.props.editInProgress}
            />
          </div>
          <div>
            <TextField
              floatingLabelText="Confirm new password"
              floatingLabelFixed={true}
              value={this.state.confirmPassword}
              onChange={e =>
                this.setState({
                  hasStartedConfirming: true,
                  confirmPassword: e.target.value
                })
              }
              onKeyDown={e => {
                if (e.keyCode === 13) this._activate();
              }}
              errorText={
                this.state.hasStartedConfirming &&
                this.state.password !== this.state.confirmPassword
                  ? "The passwords do not match."
                  : null
              }
              type="password"
              disabled={this.props.editInProgress}
            />
          </div>
          <div style={styles.actions}>
            <RaisedButton
              label={
                this.props.editInProgress ? "Activating..." : "Activate account"
              }
              disabled={
                this.props.editInProgress ||
                !this.state.password ||
                this.state.password !== this.state.confirmPassword
              }
              primary={true}
              onTouchTap={this._activate}
            />
          </div>
          <div style={styles.terms}>
            By activating your account, you agree to the Eventive{" "}
            <a
              href="https://eventive.org/terms"
              target="_blank"
              style={styles.termsLink}
            >
              Terms of Service
            </a>{" "}
            and{" "}
            <a
              href="https://eventive.org/privacy"
              target="_blank"
              style={styles.termsLink}
            >
              Privacy&nbsp;Policy
            </a>
            .
          </div>
        </form>
      </div>
    );
  }
}

export default connectToStores(Activate);



// WEBPACK FOOTER //
// ./src/app/components/activate.jsx